module.exports = __webpack_public_path__ + "static/media/mu.113b304c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mu.svg
// module id = 2164
// module chunks = 0